import { Alert } from "antd";
import React, { Suspense, lazy } from "react";
import { MainLayout } from "~/components/layout/layout.jsx";
import { Loader } from "~/components/loader/loader.jsx";
import { clubHasFinance } from "~/featureMatrix.jsx";
import { $t } from "~/i18n.js";

const AdminRoutes = lazy(() => import("./Router.jsx"));

export default function AdminRoutesRender({ children = [] }) {
  return (
    <MainLayout>
      {!clubHasFinance() && window.location.href.indexOf('financial') > -1 && (
        <Alert
          style={{ marginBottom: 12 }}
          message={$t("Financiele module niet geactiveerd")}
          description={$t(
            "Wil je de financiele module live zetten, neem dan contact op met contact@zweef.app."
          )}
          type="info"
          showIcon
        />
      )}

      <Suspense fallback={<Loader />}>
        <AdminRoutes>{children}</AdminRoutes>
      </Suspense>
    </MainLayout>
  );
}
